import { render, staticRenderFns } from "./optimizeList.vue?vue&type=template&id=802b84f8&scoped=true"
import script from "./optimizeList.vue?vue&type=script&lang=js"
export * from "./optimizeList.vue?vue&type=script&lang=js"
import style0 from "./optimizeList.vue?vue&type=style&index=0&id=802b84f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802b84f8",
  null
  
)

export default component.exports